import React from "react";

function TextInputFormControl({
  label,
  id,
  name,
  value,
  onChange,
  error,
  ...rest
}) {
  return (
    <div className="form-group">
      <label for={id} className="font-weight-bold">
        {label}
        {rest.required && <span className="text-danger mx-1">*</span>}
      </label>
      <input
        type="text"
        id={id}
        name={name}
        value={value || ""}
        onChange={onChange}
        className={`form-control form-control-sm ${error && "is-invalid"}`}
        {...rest}
      />
      {(error || error?.message) && (
        <div id="Feedback" class="invalid-feedback">
          {error?.message || (typeof error === "string" && error)}
        </div>
      )}
    </div>
  );
}

export default TextInputFormControl;
